<template>
  <div class="row">
    <div class="col-lg-12">
      <!-- Pickup Points Select (Hidden initially) -->
      <div class="form__group">

        <div class="form-control form-control--select">

          <select
              id="shop_identifier"
              v-model="selectedPoint"
              :disabled="inProgress"
              name="shop_identifier"
              @change="onSelectShop"
          >
            <option :value="null" disabled selected>
              {{ in18['attribute_shipping_shop_option'] }}
            </option>
            <option v-for="(point, index) in points" :key="index" :value="point">
              {{ point.full_address }}
            </option>
          </select>
          <validation-error :errors="errors['shipping.identifier']"/>
        </div>
      </div><!-- End Pickup Points Select -->
    </div>
    <div class="col-lg-12">
      <div class="form__group">
        <textarea
            id="shop_message"
            v-model="shipping.message"
            :placeholder="in18['attribute_shipping_message_option']"
            class="form-control  form-control--textarea"
            name="shop_message"
        ></textarea>
        <validation-error :errors="errors['shipping.message']"/>
      </div>
    </div>
  </div><!-- .row -->
</template>

<script>

import ValidationError from '../../../features/ValidationError.vue';

export default {

  name: "Shop",

  components: {
    ValidationError
  },
  emits:      [
    'update-cart',
    'country-selected',
  ],
  props:      {
    shippingMethod: {
      type:     Object,
      required: true,
    },
    shipping:       {
      type:     Object,
      required: true,
    },
    errors:         {
      type:     Object,
      required: true,
    },
    in18:           {
      type: Object,
    },
    inProgress:     {
      type: Boolean,
    },
  },

  created() {
    this.getAvailablePoints();
  },

  data() {
    return {
      points:        [],
      selectedPoint: null,
    };
  },

  methods: {
    getAvailablePoints() {
      axios.get('/api/shipping/' + this.shippingMethod.id + '/pickup-points', {
        params: {
          'country_id': this.shipping.country_id
        }
      }).then((response) => {
        this.points = response.data.points;
        this.selectedPoint = this.points[0];
        this.onSelectShop();
      });
    },

    onSelectShop() {
      this.shipping.identifier = this.selectedPoint.identifier;
      this.shipping.country_id = this.selectedPoint.country_id;
      this.shipping.zip = this.selectedPoint.zip;
      this.shipping.city = this.selectedPoint.city;
      this.shipping.address = this.selectedPoint.address;
    }
  }
};
</script>